import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MaterialModule} from 'src/app/material/material.module';
import {FeatherModule} from 'angular-feather';
import {FlexLayoutModule} from '@angular/flex-layout';
import {STablePgComponent} from './s-table-pg/s-table-pg.component';
import {BarChartWidget1Component} from './dashboard/bar-chart-widget/bar-chart-widget.component';
import {BlogCard1Component} from './dashboard/blog-card/blog-card.component';
import {Earnings1Component} from './dashboard/earnings/earnings.component';
import {MonthlySales1Component} from './dashboard/monthly-sales/monthly-sales.component';
import {PieChartWidget1Component} from './dashboard/pie-chart-widget/pie-chart-widget.component';
import {ProductPerformance1Component} from './dashboard/product-performance/product-performance.component';
import {ServiceWidget1Component} from './dashboard/service-widget/service-widget.component';
import {ShortReportWidget1Component} from './dashboard/short-report-widget/short-report-widget.component';
import {TeamReportWidget1Component} from './dashboard/team-report-widget/team-report-widget.component';
import {TimelineWidget1Component} from './dashboard/timeline-widget/timeline-widget.component';
import {TotalSales1Component} from './dashboard/total-sales/total-sales.component';
import {UserProfile1Component} from './dashboard/user-profile/user-profile.component';
import {WelcomeCard1Component} from './dashboard/welcome-card/welcome-card.component';
import {NgApexchartsModule} from 'ng-apexcharts';
import {Task1Component} from './dashboard/welcome-card/task/task.component';
import {RequestViewerComponent} from './request-viewer/request-viewer.component';
import {FormFieldsModule} from '../form-fields/form-fields.module';
import {ControlsModule} from '../controls/controls.module';
import {QuotationTableComponent} from './quotation-table/quotation-table.component';
import {LoaderModule} from '../loader/loader.module';
import {MyOrdersTableComponent} from './my-orders-table/my-orders-table.component';
import {RequestServeComponent} from './request-serve/request-serve.component';
import {RequestAlterFormComponent} from './request-alter-form/request-alter-form.component';
import {
    RequirementUpdateFormComponent
} from './request-alter-form/requirement-update-form/requirement-update-form.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {QuoteComponent} from './quote/quote.component';
import {QuoteHistoryComponent} from './quote-history/quote-history.component';
import {RequestAcceptFormComponent} from './request-accept-form/request-accept-form.component';
import {RequestTransferFormComponent} from './request-transfer-form/request-transfer-form.component';
import {RequestRejectFormComponent} from './request-reject-form/request-reject-form.component';
import {ReleaseOrderComponent} from './release-order/release-order.component';
import {ReturnOrderComponent} from './return-order/return-order.component';
import {ReleaseOrderEditComponent} from './release-order-edit/release-order-edit.component';
import {ReleaseOrderCancelComponent} from './release-order-cancel/release-order-cancel.component';
import {PickupReturnComponent} from './pickup-return/pickup-return.component';
import {ReleaseOrderRevalidateComponent} from './release-order-revalidate/release-order-revalidate.component';
import {CommunicationsComponent} from './communications/communications.component';
import {RequestTimelineComponent} from './request-timeline/request-timeline.component';
import {ReturnOrderEditComponent} from './return-order-edit/return-order-edit.component';
import {ReturnContainerComponent} from './return-container/return-container.component';
import {QuoteNegotiateComponent} from './quote-negotiate/quote-negotiate.component';
import {ExternalDORevalidationComponent} from './external-do-revalidation/external-do-revalidation.component';
import {NudgeRequestorFormComponent} from './nudge-requestor-form/nudge-requestor-form.component';
import {FeedbackComponent} from './feedback/feedback.component';
import {RequestInitialComponent} from './request-initial/request-initial.component';
import {ColdLeadsComponent} from './cold-leads/cold-leads.component';
import {DefaultStatusChangeComponent} from './request-status-change-form/request-status-change-form.component';
import {RequestConfirmBookingComponent} from './request-confirm-booking/request-confirm-booking.component';
import {ReturnOrderCancelComponent} from './return-order-cancel/return-order-cancel.component';
import {ReturnOrderRevalidateComponent} from './return-order-revalidate/return-order-revalidate.component';
import {
    ExternalReturnRevalidationComponent
} from './external-return-revalidation/external-return-revalidation.component';
import {KeyInsightsComponent} from './key-insights/key-insights.component';
import {DepotFormComponent} from './depot-form/depot-form.component';
// import { NgParticlesModule } from "ng-particles";
import {RequestDocumentsComponent} from './request-documents/request-documents.component';
import {MyRequestsTableComponent} from './my-requests-table/my-requests-table.component';
import {MyRequestViewComponent} from './my-request-view/my-request-view.component';
import {ReturnContainersComponent} from './return-containers/return-containers.component';
import {PickerModule} from '@ctrl/ngx-emoji-mart';
import {EmojiModule} from '@ctrl/ngx-emoji-mart/ngx-emoji';
import {RequestUpdateFormComponent} from './request-alter-form/request-update-form/request-update-form.component';
import {MarkdownModule} from 'ngx-markdown';
import {QuillModule} from 'ngx-quill';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {
    ErrorTooltipListPipe,
    SupplierPickupReturnContainersComponent
} from './supplier-pickup-return-containers/supplier-pickup-return-containers.component';
import {RequestFilterFormComponent} from './request-filter-form/request-filter-form.component';
import {ReviewQuotationComponent} from './review-quotation/review-quotation.component';
import {ContainerslistforpickupComponent} from './containerslistforpickup/containerslistforpickup.component';
import {ContainerslistforreturnComponent} from './containerslistforreturn/containerslistforreturn.component';
import {TimelineDetailedComponent} from './timeline-detailed/timeline-detailed.component';
import {TimelineComponent} from './timeline/timeline.component';
import {LeaseQuoteTableComponent} from './quoteTable/lease-quote-table/lease-quote-table.component';
import {OnewayQuoteTableComponent} from './quoteTable/oneway-quote-table/oneway-quote-table.component';
import {TradeQuoteTableComponent} from './quoteTable/trade-quote-table/trade-quote-table.component';
import {InfoContentComponent} from './info-content/info-content.component';
import {
    PickupDropoffScheduleLeaseComponent
} from './pickup-dropoff-schedule-lease/pickup-dropoff-schedule-lease.component';
import {
    LeaseQuoteRemarksComponent
} from './quoteTable/lease-quote-table/lease-quote-remarks/lease-quote-remarks.component';
import {LeadrequestUpdateFormComponent} from './leadrequest-update-form/leadrequest-update-form.component';
import {PipesModule} from 'src/app/pipes/pipes.module';
import {EroAddUpdateComponent} from './ero-add-update/ero-add-update.component';
import {LeaseReviewQuotationComponent} from './lease-review-quotation/lease-review-quotation.component';
import {AddPickupScheduleComponent} from './add-pickup-schedule/add-pickup-schedule.component';
import {AddDropoffScheduleComponent} from './add-dropoff-schedule/add-dropoff-schedule.component';
import {QuoteRemarksComponent} from './quoteTable/quote-remarks/quote-remarks.component';
import {CompanyDetailsComponent} from './company-profile/company-details/company-details.component';
import {CompanyBankDetailsComponent} from './company-profile/company-bank-details/company-bank-details.component';
import {
    CompanyBranchDetailsFormComponent
} from './company-profile/company-branch-details-form/company-branch-details-form.component';
import {CompanyKycDetailsComponent} from './company-profile/company-kyc-details/company-kyc-details.component';
import {CommunityEnhancementComponent} from './community-enhancement/community-enhancement.component';
import {CommunitySuggestionComponent} from './community-suggestion/community-suggestion.component';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {ReportsModule} from '../reports/reports.module';
import {QuickAddSalesPersonComponent} from './quick-add-salesperson/quick-add-salesperson.component';
import {
    ContainersListForReexportComponent
} from './containers-list-for-reexport/containers-list-for-reexport.component';
import {ReexportContainersComponent} from './reexport-containers/reexport-containers.component';
import {ValidateContainersComponent} from '../../validate-containers/validate-containers.component';
import {ContainerListComponent} from './container-list/container-list.component';
import {ContainerlistforpickupComponent} from './containerlistforpickup/containerlistforpickup.component';
import {EmptyRepoReviewQuotationComponent} from './empty-repo-review-quotation/empty-repo-review-quotation.component';
import {EmptyRepoQuoteTableComponent} from './quoteTable/empty-repo-quote-table/empty-repo-quote-table.component';
import {
    EmptyRepoAddChargesComponent
} from './quoteTable/empty-repo-quote-table/empty-repo-add-charges/empty-repo-add-charges.component';
import {NgSelectModule} from "@ng-select/ng-select";
import {VesselMovementDetailsComponent} from './vessel-movement-details/vessel-movement-details.component';
import {MapDoComponent} from './map-do/map-do.component';
import {BookingChargesComponent} from './booking-charges/booking-charges.component';
import {LeaseAfterConfirmationComponent} from './lease-after-confirmation/lease-after-confirmation.component';
import {
    OnewayTradeAfterConfirmationComponent
} from './oneway-trade-after-confirmation/oneway-trade-after-confirmation.component';
import {
    RequirementContainersComponent
} from './booking-charges/requirement-containers/requirement-containers.component';
import {ApprovalLogComponent} from './approval-log/approval-log.component';
import {RejectionReasonComponent} from './rejection-reason/rejection-reason.component';
import {ChargeDetailsComponent} from './booking-charges/charge-details/charge-details.component';
import {BookingReopenLogsComponent} from './booking-reopen-logs/booking-reopen-logs.component';
import {StockInfoComponent} from './stock-info/stock-info.component';
import {ViewReopenLogsComponent} from './view-reopen-logs/view-reopen-logs.component';
import {AddInvoicePartyComponent} from './add-invoice-party/add-invoice-party.component';
import {StockReportListComponent} from './stock-report-list/stock-report-list.component';
import {RouterModule} from "@angular/router";
import {StockDetailsComponent} from './stock-details/stock-details.component';
import {NgxSliderModule} from "@angular-slider/ngx-slider";

// import { SalespersonModule } from '../one-way/quick-add-saleperson/salesperson/salesperson.module';

@NgModule({
    declarations: [
        STablePgComponent,
        BarChartWidget1Component,
        BlogCard1Component,
        Earnings1Component,
        MonthlySales1Component,
        PieChartWidget1Component,
        ProductPerformance1Component,
        ServiceWidget1Component,
        ShortReportWidget1Component,
        TeamReportWidget1Component,
        TimelineWidget1Component,
        TotalSales1Component,
        UserProfile1Component,
        WelcomeCard1Component,
        Task1Component,
        RequestViewerComponent,
        QuotationTableComponent,
        MyOrdersTableComponent,
        MyRequestsTableComponent,
        RequestServeComponent,
        RequestAlterFormComponent,
        RequirementUpdateFormComponent,
        RequestUpdateFormComponent,
        QuoteComponent,
        QuoteHistoryComponent,
        RequestAcceptFormComponent,
        RequestTransferFormComponent,
        RequestRejectFormComponent,
        ReleaseOrderComponent,
        DefaultStatusChangeComponent,
        ReturnOrderComponent,
        ReleaseOrderEditComponent,
        ReleaseOrderCancelComponent,
        PickupReturnComponent,
        ReleaseOrderRevalidateComponent,
        CommunicationsComponent,
        RequestTimelineComponent,
        ReturnOrderEditComponent,
        ReturnContainerComponent,
        QuoteNegotiateComponent,
        ExternalDORevalidationComponent,
        NudgeRequestorFormComponent,
        FeedbackComponent,
        RequestInitialComponent,
        ColdLeadsComponent,
        RequestConfirmBookingComponent,
        ReturnOrderRevalidateComponent,
        ReturnOrderCancelComponent,
        ExternalReturnRevalidationComponent,
        KeyInsightsComponent,
        DepotFormComponent,
        RequestDocumentsComponent,
        MyRequestViewComponent,
        ReturnContainersComponent,
        SupplierPickupReturnContainersComponent,
        ErrorTooltipListPipe,
        RequestFilterFormComponent,
        ReviewQuotationComponent,
        ContainerslistforpickupComponent,
        ContainerslistforreturnComponent,
        TimelineDetailedComponent,
        TimelineComponent,
        LeaseQuoteTableComponent,
        OnewayQuoteTableComponent,
        TradeQuoteTableComponent,
        InfoContentComponent,
        PickupDropoffScheduleLeaseComponent,
        LeaseQuoteRemarksComponent,
        QuoteRemarksComponent,
        LeadrequestUpdateFormComponent,
        EroAddUpdateComponent,
        LeaseReviewQuotationComponent,
        AddPickupScheduleComponent,
        AddDropoffScheduleComponent,
        CompanyDetailsComponent,
        CompanyBankDetailsComponent,
        CompanyBranchDetailsFormComponent,
        CompanyKycDetailsComponent,
        CommunityEnhancementComponent,
        CommunitySuggestionComponent,
        QuickAddSalesPersonComponent,
        ContainersListForReexportComponent,
        ReexportContainersComponent,
        ValidateContainersComponent,
        ContainerListComponent,
        ContainerlistforpickupComponent,
        EmptyRepoReviewQuotationComponent,
        EmptyRepoQuoteTableComponent,
        EmptyRepoAddChargesComponent,
        VesselMovementDetailsComponent,
        MapDoComponent,
        BookingChargesComponent,
        LeaseAfterConfirmationComponent,
        OnewayTradeAfterConfirmationComponent,
        RequirementContainersComponent,
        ApprovalLogComponent,
        RejectionReasonComponent,
        ChargeDetailsComponent,
        BookingReopenLogsComponent,
        StockInfoComponent,
        ViewReopenLogsComponent,
        AddInvoicePartyComponent,
        StockReportListComponent,
        StockDetailsComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FeatherModule,
        FlexLayoutModule,
        NgApexchartsModule,
        FormFieldsModule,
        ControlsModule,
        LoaderModule,
        FormsModule,
        // NgParticlesModule,
        ReactiveFormsModule,
        PickerModule,
        EmojiModule,
        MarkdownModule.forRoot(),
        QuillModule.forRoot(),
        DragDropModule,
        PipesModule,
        ClipboardModule,
        ReportsModule,
        NgSelectModule,
        RouterModule,
        NgxSliderModule,
        // SalespersonModule
    ],
    exports: [
        STablePgComponent,
        BarChartWidget1Component,
        BlogCard1Component,
        Earnings1Component,
        MonthlySales1Component,
        PieChartWidget1Component,
        ProductPerformance1Component,
        ServiceWidget1Component,
        ShortReportWidget1Component,
        TeamReportWidget1Component,
        TimelineWidget1Component,
        TotalSales1Component,
        UserProfile1Component,
        WelcomeCard1Component,
        Task1Component,
        RequestViewerComponent,
        QuotationTableComponent,
        MyOrdersTableComponent,
        MyRequestsTableComponent,
        RequestServeComponent,
        RequestAlterFormComponent,
        RequirementUpdateFormComponent,
        RequestUpdateFormComponent,
        QuoteComponent,
        QuoteHistoryComponent,
        RequestAcceptFormComponent,
        RequestTransferFormComponent,
        RequestRejectFormComponent,
        DefaultStatusChangeComponent,
        ReleaseOrderEditComponent,
        ReleaseOrderCancelComponent,
        ReleaseOrderRevalidateComponent,
        PickupReturnComponent,
        CommunicationsComponent,
        ReturnOrderEditComponent,
        ReturnOrderCancelComponent,
        ReturnOrderRevalidateComponent,
        QuoteNegotiateComponent,
        ExternalDORevalidationComponent,
        NudgeRequestorFormComponent,
        FeedbackComponent,
        RequestInitialComponent,
        ColdLeadsComponent,
        RequestConfirmBookingComponent,
        ExternalReturnRevalidationComponent,
        KeyInsightsComponent,
        DepotFormComponent,
        RequestDocumentsComponent,
        MyRequestViewComponent,
        SupplierPickupReturnContainersComponent,
        RequestFilterFormComponent,
        ReviewQuotationComponent,
        TimelineDetailedComponent,
        InfoContentComponent,
        LeaseQuoteRemarksComponent,
        QuoteRemarksComponent,
        LeadrequestUpdateFormComponent,
        EroAddUpdateComponent,
        AddPickupScheduleComponent,
        AddDropoffScheduleComponent,
        CompanyDetailsComponent,
        CompanyBankDetailsComponent,
        CompanyBranchDetailsFormComponent,
        CompanyKycDetailsComponent,
        CommunitySuggestionComponent,
        ValidateContainersComponent,
        ContainerListComponent,
        EmptyRepoAddChargesComponent,
        ApprovalLogComponent,
        RejectionReasonComponent,
        RequirementContainersComponent,
        ChargeDetailsComponent,
        BookingReopenLogsComponent,
        StockInfoComponent,
        ViewReopenLogsComponent,
        AddInvoicePartyComponent
    ]
})
export class ExternalDashboardModule {
}
